import { IGetAllCargosForHabilidadesCargosUseCase } from "../../../presentation/useCases/read/get_all_cargos_for_habilidades_cargos_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { CargoHabilidadeCargo } from "../../models/cargo_habilidade_cargo";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetAllCargosForHabilidadesCargosUseCase
 */

export class GetAllCargosForHabilidadesCargosUseCase
  extends BasePaginatedUseCase<CargoHabilidadeCargo>
  implements IGetAllCargosForHabilidadesCargosUseCase {
  constructor(private readonly repository: IRhRepository) {
    super();
  }

  async getAllCargos(
    idHabilidade: number,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllCargoHabilidadeCargo(
      idHabilidade,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
